(function() {
    'use strict';

    a3_cabin_reports.controller('CompetenceModalCtrl', CompetenceModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name CompetenceModalCtrl
     * @description 
     * Show competence grading helper
     * @ngInject
     */

    function CompetenceModalCtrl($scope, $uibModalInstance, competence){
        $scope.close = close;
        $scope.competence = competence;

        /**
         * Close the modal
         * @memberof CompetenceModalCtrl
         */
        function close(){
            $uibModalInstance.close($scope.competence.Grading);
        }
    }
})();